import { Typography, styled, Container, Dialog } from '@mui/material';

import { HEADER_HEIGHT } from 'theSource/components/Header/HeaderStyled';
import { Link } from 'theSource/components/Link';

export const BenefitDetailsTitleStyled = styled('h2')(({ theme }) => ({
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(4),
}));

export const BenefitDetailsContainerStyled = styled(Container)(({ theme }) => ({
  border: `0.1rem solid ${theme.palette.grey[200]}`,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.common.white,
  padding: '16px',
  paddingTop: '0',
  maxWidth: 'unset',
}));

export const LearnMoreLinkStyled = styled(Link)({
  fontWeight: 'bold',
});

export const BackLinkStyled = styled(Link)({
  paddingLeft: '16px',
});

export const BenefitDetailsDialogStyled = styled(Dialog)({
  overflow: 'auto',
  height: '100%',
  width: '100%',
  border: 'none',
  paddingTop: HEADER_HEIGHT,
});

export const BenefitDetailsContentStyled = styled(Typography)({
  padding: '16px',
});
